import * as Sentry from '@sentry/browser';

const isAndroidBelow5 = false; // TODO

declare global {
  interface Window {
    Sentry: typeof Sentry;
  }
}

class SentryLogger {
  private isInitialized: boolean;
  constructor() {
    this.isInitialized = !!window.Sentry;
    this.init();
  }

  shouldCaptureError = () => {
    return (
      this.isInitialized &&
      process.env.REACT_APP_SENTRY_ENABLED === 'true' &&
      isAndroidBelow5 === false
    );
  };

  init = () => {
    if (!this.isInitialized) {
      return;
    }

    Sentry.onLoad(() => {
      Sentry.init({
        release: `passenger-pwa@${process.env.GIT_CURRENT_TAG}`,
        environment: process.env.BOILERPLATE_PWA_APP_ENV,
      });
    });
  };

  captureError = (
    message: string,
    details: Record<string, unknown>,
    id: string,
    level: Sentry.Severity = Sentry.Severity.Error,
    userData,
  ) => {
    if (this.shouldCaptureError() !== true) {
      return;
    }
    let resolve;
    const captureErrorPromise = new Promise((res, _rej) => {
      resolve = res;
    });
    Sentry.forceLoad();
    Sentry.withScope(async scope => {
      scope.setLevel(level);
      scope.setExtras(details);
      if (details) {
        scope.addBreadcrumb({
          category: 'details',
          message: message,
          data: details,
          timestamp: new Date().getTime() / 1000,
          level: 'info' as Sentry.Severity,
        });
      }
      if (userData) {
        scope.setUser({
          id: userData.profile.user_id,
          cellphone: userData.profile.cellphone,
          email: userData.profile.email,
        });
      }
      const errorId = await Sentry.captureMessage(message);
      resolve(errorId);
    });

    return captureErrorPromise;
  };

  showReportDialog = id => {
    Sentry.showReportDialog({ eventId: id });
  };
}

let instance;

export default function getInstance() {
  if (instance) {
    return instance;
  }
  instance = new SentryLogger();
  return instance;
}
